<template>
    <div v-bind:class="{'places__item': true, 'places__item--noDistance': !hasDistance(), 'places__item--active': selectedContactId === contact.token }"
         :id="guid()"
         v-on:click="onSelect ? ()=>{} : clickme(contact.company.coordinates.location)">
        <div class="places__itemHeader">
            <span class="places__itemTitle">
                <strong>{{contact.company.name}}</strong>
                <span class="places__itemDistance" v-if="hasDistance()">
                    <span class="places__itemDistanceValue">{{formatDistance()}}</span> km
                </span>
                <span class="places__distanceSlash" v-if="hasDistance()"> - </span>
            </span>
        </div>
        <address class="places__itemAddress">
            {{contact.company.coordinates.address}}
        </address>
        <div class="places__itemContacts">
            <span class="places__itemContactsItem" v-if="contact.company.contact.phone">
                tel.: <a v-bind:href="'tel:'+contact.company.contact.phone" class="link">{{contact.company.contact.phone}}</a>
            </span>
            <span class="places__itemContactsItem" v-if="contact.company.contact.email">
                e-mail: <a v-bind:href="'mailto:'+contact.company.contact.email" class="link">{{contact.company.contact.email}}</a>
            </span>
        </div>
        <div class="certification"
             v-if="['companies', 'contacts'].indexOf(locatorType) !== -1 && contact.certifications.length">
            <span>
                certifikace:
                <span v-bind:class="{certification__item: true, 'certification__item--expired': isExpired(certification)}"
                      v-for="(certification, index) in contact.certifications">
                    {{type(certification)}} (do {{formatDate(certification)}})<span
                        v-if="index+1 < contact.certifications.length">, </span>
                </span>
            </span>
        </div>
        <button type="button" class="button view-bordered" v-if="onSelect" v-on:click="onSelect(contact.token)">
            Vybrat
        </button>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import moment from 'moment';

    export default {
        name: 'LocatorContact',
        props: {
            contact: Object,
            onSelect: {
                type: Function | null,
                default: null,
            },
            selectedContactId: {
                type: String | Number | null,
                default: null,
            }
        },
        computed: {
            ...mapGetters('locator', ['locatorType']),
        },
        methods: {
            ...mapActions('locator', ['setMapCenter', 'setMapZoom']),
            formatDistance() {
                const {distance} = this.contact;
                if (distance > 1) {
                    return parseFloat(distance).toFixed(0);
                }
                return parseFloat(distance).toFixed(2);
            },
            hasDistance() {
                return 'distance' in this.contact && this.contact.distance;
            },
            guid() {
                return 'contact-' + this.contact.id;
            },
            formatDate(certification) {
                const {until} = certification;
                return moment(until).format('D. M. YYYY')
            },
            isExpired(certification) {
                const date = moment();
                const {until} = certification;
                return !moment(until).isAfter(date)
            },
            type(certification) {
                const {type} = certification;
                const options = {
                    'sdk': 'sádrokarton',
                    'drywall': 'sádrokarton',
                    'woodwork': 'dřevostavby'
                }

                return options[type];
            },
            clickme(location) {
                this.setMapCenter({lat: location.lat, lng: location.lon});
                this.setMapZoom(17);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/locator/Contact.vue